import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "../Styles/Reviews.css";

const customerReviews = [
  {
    name: "Michael R.",
    role: "Homeowner",
    message:
      "Qualified Stucco did an amazing job on our home exterior. The team was professional, clean, and finished ahead of schedule. Our house looks brand new! Highly recommend them.",
    rating: 5,
  },
  {
    name: "Sarah T.",
    role: "Business Owner",
    message:
      "We hired them for drywall painting on our office building. The quality of work was outstanding. They paid attention to every detail and the results speak for themselves.",
    rating: 5,
  },
  {
    name: "James L.",
    role: "Homeowner",
    message:
      "The popcorn ceiling removal was done perfectly. They were careful with our furniture, cleaned up after themselves, and the ceilings look incredible. Best decision we made!",
    rating: 5,
  },
  {
    name: "Patricia W.",
    role: "Property Manager",
    message:
      "After storm damage, we needed demolition repair urgently. Qualified Stucco responded quickly and restored our walls better than they were before. Excellent emergency service!",
    rating: 5,
  },
];

function Reviews() {
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent(current <= 0 ? customerReviews.length - 1 : current - 1);
  const next = () => setCurrent(current >= customerReviews.length - 1 ? 0 : current + 1);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  });

  const review = customerReviews[current];

  return (
    <section className="review-section">
      <div className="review-inner">
        <div className="review-left">
          <span className="section-label">TESTIMONIALS</span>
          <h2>Trusted By Hundreds<br />of Customers</h2>
          <p>Our work speaks for itself. See what our clients have to say about our quality and service.</p>
          <div className="review-nav-btns">
            <button className="review-nav-btn" onClick={prev} aria-label="Previous review">
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <span className="review-nav-count">{current + 1} / {customerReviews.length}</span>
            <button className="review-nav-btn" onClick={next} aria-label="Next review">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>

        <div className="review-right">
          <div className="review-card">
            <FontAwesomeIcon icon={faQuoteLeft} className="review-quote-icon" />
            <div className="review-stars">
              {"★".repeat(review.rating)}
            </div>
            <p className="review-message">{review.message}</p>
            <div className="review-author-info">
              <div className="review-avatar">
                {review.name.charAt(0)}
              </div>
              <div>
                <p className="review-name">{review.name}</p>
                <p className="review-role">{review.role}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Reviews;
